import styled from "styled-components/macro";

export const SummaryWrapper = styled.div`
	padding: 15px;
`;
